import { render } from "./SupplierType.vue?vue&type=template&id=14c5de78&scoped=true"
import script from "./SupplierType.vue?vue&type=script&lang=js"
export * from "./SupplierType.vue?vue&type=script&lang=js"

import "./SupplierType.vue?vue&type=style&index=0&id=14c5de78&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14c5de78"]])

export default __exports__